import React from 'react';
import { ActivityIcon, BadgeCheckIcon, BellIcon, BuildingIcon, ClipboardCheckIcon, FileBadgeIcon, FileClockIcon, KeyRoundIcon, GiftIcon, MapPinIcon, MessagesSquareIcon, PaletteIcon, FlagIcon, HeadphonesIcon, LayoutDashboardIcon, RocketIcon, ScaleIcon, ShieldAlertIcon, UsersIcon } from 'lucide-react';
import { OperatorShell } from './OperatorShell';
const GROUPS = [{
  label: 'Operations',
  items: [{
    to: '/admin/home',
    label: 'What needs attention',
    icon: BellIcon
  }, {
    to: '/admin',
    label: 'Platform overview',
    icon: LayoutDashboardIcon,
    end: true
  }, {
    to: '/admin/support',
    label: 'Support desk',
    icon: HeadphonesIcon
  }]
}, {
  label: 'People',
  items: [{
    to: '/admin/users',
    label: 'Users and accounts',
    icon: UsersIcon
  }]
}, {
  label: 'Governance',
  items: [{
    to: '/admin/governance',
    label: 'Tenants, staff and roles',
    icon: KeyRoundIcon
  }, {
    to: '/admin/audit',
    label: 'Audit log',
    icon: FileClockIcon
  }, {
    to: '/admin/architecture',
    label: 'Platform architecture',
    icon: FileClockIcon
  }]
}, {
  label: 'Platform',
  items: [{
    to: '/admin/launch',
    label: 'Campus launch control',
    icon: RocketIcon
  }, {
    to: '/admin/health',
    label: 'System health',
    icon: ActivityIcon
  }, {
    to: '/admin/readiness',
    label: 'Production readiness',
    icon: ClipboardCheckIcon
  }]
}, {
  label: 'Experience management',
  items: [{
    to: '/admin/experience',
    label: 'Design variants',
    icon: PaletteIcon
  }]
}, {
  label: 'Campus network',
  items: [{
    to: '/admin/network',
    label: 'Network control centre',
    icon: MapPinIcon
  }]
}, {
  label: 'Academic identity',
  items: [{
    to: '/admin/verification',
    label: 'Verification control centre',
    icon: BadgeCheckIcon
  }]
}, {
  label: 'Social & campus life',
  items: [{
    to: '/admin/social',
    label: 'Social control centre',
    icon: MessagesSquareIcon
  }]
}, {
  label: 'Academic services',
  items: [{
    to: '/admin/services',
    label: 'Services control centre',
    icon: FileBadgeIcon
  }]
}, {
  label: 'Financial operations',
  items: [{
    to: '/admin/finance',
    label: 'Ledger and reconciliation',
    icon: ScaleIcon
  }, {
    to: '/admin/campagift',
    label: 'CampaGift control centre',
    icon: GiftIcon
  }]
}];
const SECTIONS = [{
  label: 'Institutions',
  icon: BuildingIcon
}, {
  label: 'Accounts',
  icon: UsersIcon
}, {
  label: 'Moderation queue',
  icon: FlagIcon
}, {
  label: 'Reported accounts',
  icon: ShieldAlertIcon
}, {
  label: 'Verification queue',
  icon: BadgeCheckIcon
}, {
  label: 'Audit log',
  icon: FileClockIcon
}];
export function AdminShell() {
  return <OperatorShell consoleKey="admin" consoleName="Campuzon admin" scopeLine="Platform operations · Nigeria region" groups={GROUPS} summary={<div data-id="element-4475" data-mp="smdkiw6b6a75">
          <p className="text-[12px] leading-5 text-ink-muted" data-id="element-4476" data-mp="slu97yb5yk23">
            Moderation, verification and sensitive-data access are separated by design. Every action
            below is attributed and logged.
          </p>
          <ul className="mt-4 space-y-1.5 border-t border-line pt-3" data-id="element-4477" data-mp="nil0r2vx004f">
            {SECTIONS.map(section => {
        const Icon = section.icon;
        return <li key={section.label} className="flex items-center gap-2 text-[12px] text-ink-muted" data-id="element-4478" data-mp="x7usuiqrdisj">
                  <Icon className="h-3.5 w-3.5 shrink-0 text-ink-subtle" data-id="element-4479" data-mp="11b0ypp9yl7yh" />
                  {section.label}
                </li>;
      })}
          </ul>
        </div>} data-id="element-4474" data-mp="242bwb7svfac2" />;
}